import { useMutation, useQueryClient } from "@tanstack/react-query";
import { proveedorManualApi } from "@/features/proveedor-manual/services/proveedor-manual.api";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";

export function useSeleccionarProveedorManual(solicitudId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (numeroProveedor: number) => proveedorManualApi.seleccionar(solicitudId, numeroProveedor),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      toastExito({ title: "Proveedor asignado", message: `#${solicitud.proveedor?.numeroProveedor ?? ""} ${solicitud.proveedor?.razonSocial ?? ""}` });
    },
    onError: toastErrorApi,
  });
}
